import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';


import CloseIcon from '@mui/icons-material/Close';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import PropTypes from "prop-types";
import DialogActions from "@mui/material/DialogActions";
import LoadingButton from "@mui/lab/LoadingButton";
import PersonAddIcon from '@mui/icons-material/PersonAdd';



import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import {t} from "i18next";
import {useAxStore} from "../store/axStore";
import {RHFTextField} from "../components/hook-form";
import Iconify from "../components/iconify";
import {useSnackbar} from "../components/snackbar";
import {useBoolean} from "../hooks/use-boolean";
import axios from "../utils/axios";

const ChangeUserEmailModal = ({open, setOpen,userid,curEmail,onEmailChange}) => {

  const axStore=useAxStore();

  const { enqueueSnackbar } = useSnackbar();


  const emailAreOk = useBoolean(false);
  const emailIsChanging = useBoolean(false);
  const [newEmail,setNewEmail] = useState(curEmail);
  const [originalEmail,setOriginalEmail] = useState(curEmail);
  const [emailMessage,setEmailMessage] = useState('');

  const handleSubmit = async () => {
  if(!emailIsChanging.value) {
    emailIsChanging.onTrue()
    const jwt = localStorage.getItem('axjwt');
    if (jwt&&newEmail) {

      const postValues = new FormData();
      postValues.append('newEmail', newEmail);
      postValues.append('uid', userid); // user id to whom are we going to change the email
      postValues.append('action', 'change_user_email');


      axios.post('https://api.administrix.pro/v1/post/',
        postValues, {
          headers: {'Authorization': `Bearer ${jwt}`}
        })
        .then((response => {
          if (response.data.data) {
            const {data} = response.data;
            const {meta} = response.data;
            if (meta.jwt) localStorage.setItem('axjwt', meta.jwt);else{
              localStorage.removeItem('axjwt');
              axStore.setCurrentUser({})
              window.location.href = '/auth/jwt/login?returnTo=%2Fdashboard';
            }

            if (data.status === 1) {

                enqueueSnackbar(t('user.great_email_was_succ_changed'), {variant: `success`, autoHideDuration: 6000});
              onEmailChange(newEmail);
              setOpen(false);

            } else {
                enqueueSnackbar(t('user.sorry_email_was_change_failed'), {variant: `error`, autoHideDuration: 6000});

              }


          } else if (response.data.error) {
//            const {error} = response.data;
            enqueueSnackbar(`${t('an_error_occured')}: ${response.data.error.title}`, {variant: `error`, autoHideDuration: 6000});
            console.log('picxa hir')
          }

        }))
        .catch(error => {
          console.log("any changing passw  fetch api error");

        })

    }
    emailIsChanging.onFalse()
  }
  };

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  useEffect(()=> {


      if (isValidEmail(newEmail)) {
        if(newEmail!==originalEmail) {
          emailAreOk.onTrue()
          setEmailMessage(t('user.great_you_can_change_email'));
        }else{
          setEmailMessage(t('user.you_cannot_change_email_because_is_same_as_previous'));
          emailAreOk.onFalse()
        }
      } else {
        setEmailMessage(t('user.incorrect_email_format'));
        emailAreOk.onFalse()
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[newEmail])

  useEffect(()=> {
// console.log('edit user email modal opened')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange1 = (event) => {
    setNewEmail(event.target.value);
    // const pass1=event.target.value;

/*
    if(isStrongPassword(pass1)){
      setPasswMessage1('email je silné.');
      paswword1IsStrong.onTrue()
    }else{
      setPasswMessage1('email nespĺňa požadované kritériá.');
      paswword1IsStrong.onFalse()
    }
*/
  };

  /* function isStrongPassword(passwordValue) {
    // Define regex patterns for different character types
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    // const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    // Check length
    if (passwordValue.length < 8) {
      return false; // Password is too short
    }

    // Check for presence of required character types
    if (!uppercaseRegex.test(passwordValue) ||
      !lowercaseRegex.test(password) ||
      !numberRegex.test(passwordValue))  {
      return false; // Missing required character types
    }
    // Passed all checks
    return true;
  }
*/

  useEffect(() => {
    if (curEmail) {
      setNewEmail(curEmail);
      setOriginalEmail(curEmail);
    }
  }, [curEmail]);
  return (

    <Dialog open={open}  maxWidth="sm" fullWidth>
        <DialogTitle>
          {t('user.change_email')}
          <IconButton
            aria-label="close"
             onClick={()=>setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>

            <p>{t('user.set_new_email')} <br/><br/>

          </p>


          <Grid sm={12}>
            <FormControl sx={{m: 1, width: "100%"}} variant="outlined" sm>
              <InputLabel htmlFor="outlined-adornment-password">email</InputLabel>
              <OutlinedInput
                id="passw1"
                name="passw1"
                value={newEmail}
                type='text'
                onChange={handleChange1}
                label="email"
              />
              <FormHelperText id="filled-weight-helper-text" style={{color:emailAreOk.value ? '#0f6e0c' : '#FF0000'}}>{emailMessage}</FormHelperText>
            </FormControl>
</Grid>

          </DialogContentText>
        </DialogContent>
      <DialogActions>


        {emailAreOk.value&&<LoadingButton
          /* type="submit" */
           onClick={handleSubmit}
          variant="contained"
          size="large"
          // loading={isSubmitting}
          startIcon={<SendTimeExtensionIcon />}
          sx={{ml: 2, backgroundColor: '#047505', color: '#fff'}}
        >
          {t("user.change_email")}
        </LoadingButton>
        }


        <Button variant="outlined" onClick={()=>setOpen(false)}>
          {t("close")}
        </Button>
      </DialogActions>
      </Dialog>
  );
};
ChangeUserEmailModal.propTypes = {
  open: PropTypes.bool,
  userid:PropTypes.number,
  setOpen:PropTypes.func,
  onEmailChange:PropTypes.func,
  curEmail:PropTypes.string

};
export default ChangeUserEmailModal;
